import React, {useRef, useState} from "react";
import styles from "./login.module.css";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Button, Snackbar } from "@mui/material";
import {Link} from "react-router-dom";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const Login = () => {


    const handleClick = async () => {
        try {
        const res = await fetch("/api/getUsers");
        const data = await res.json();
        
         const match = checkEmail(data, userRef.current.value)
            if(match){ 
            setMessage("User Found")
        } else {
        setMessage("Login Failed")
        }
        setOpen(true);

        } catch (e) {
        console.error(e);
        }
        
    }

    const handleLogin = async () => {

        const username = userRef.current.value;
        const password = passRef.current.value;

        try {
            const response = await fetch("/api/login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ username, password }),
            });

            const data = await response.json();

            if (response.ok && data.success) {

                localStorage.setItem("token", data.token);
                
                window.location.href = "/businessHome"; 
            } else {
                alert(data.message || "Login failed. Please check your credentials.");
            }
        } catch (error) {
            console.error("Login error:", error);
            alert("An error occurred during login.");
        }
    };

    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");

    const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
    };

    const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
    );


    function checkEmail(users, emailInput) {
        return users.find(user => user.email.toLowerCase() === emailInput.toLowerCase());
    }
    
    const buttonStyle ={
    	borderRadius: 0,        
    	borderWidth: '4px',           
    	borderColor: 'black',
        width: "100px",         
    	color: 'black',
    	fontSize:'20px',
    	fontWeight:'bold',
        whiteSpace: "nowrap",
    	'&:hover': {
    		borderColor: 'black',
      		backgroundColor: 'rgba(0,0,0,0.05)', 
    	}
    }

    const userRef = useRef();
    const passRef = useRef();

    return (
    <div style={{ 
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingBottom: 80,
            paddingTop: 80,
            }}>
        <div className={styles.welcomeBox}>
            <div style={{
                paddingTop:150,
            }}>
                Welcome
            </div>
        </div>
        <div className={styles.loginBox}>
            <div style={{paddingBottom:10, paddingTop:50}}>
                Enter account credentials below
            </div>
            <TextField inputRef={userRef} id="outlined-basic" label="Username" variant="outlined" style={{paddingBottom:10}}/>
            <TextField inputRef={passRef} id="outlined-basic" label="Password" type="password" variant="outlined" style={{paddingBottom:10}}/>
            {/* <div>
                <FormControlLabel
                    control={
                    <Checkbox
                    name="RememberUser"
                     />}
                label="Remember me"/>
                <Link to="/forgotPassword">Forgot Password</Link>
            </div> */}

            {/* <button className={styles.loginButton}
                    onMouseEnter={(e) => (e.target.style.backgroundColor = "rgb(0, 2, 15)", e.target.style.color ="rgb(255, 255, 255)")}
                    onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent", e.target.style.color ="rgb(0, 2, 15)")}
                    >
                    Sign In
            </button> */}
            <Button variant="outlined" sx={buttonStyle} onClick={() => handleLogin()}>
                                        Sign In
            </Button>
            <Snackbar
                open={open}
                autoHideDuration={2000}
                onClose={handleClose}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                message={message}
                action={action}
            />
        </div>
    </div>

    );
};

export default Login;
